module.exports = __webpack_public_path__ + "content/21d6e5b0102583c3d7586e21793cb6f0.jpeg";